var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiShoppingBags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:shopping-bags"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8438 14.3621C13.8438 14.1134 13.9425 13.875 14.1183 13.6991C14.2942 13.5233 14.5326 13.4246 14.7812 13.4246H26.9969C27.2455 13.4246 27.484 13.5233 27.6598 13.6991C27.8356 13.875 27.9344 14.1134 27.9344 14.3621V27.6042C27.9344 27.8529 27.8356 28.0913 27.6598 28.2672C27.484 28.443 27.2455 28.5417 26.9969 28.5417H14.7812C14.5326 28.5417 14.2942 28.443 14.1183 28.2672C13.9425 28.0913 13.8438 27.8529 13.8438 27.6042V14.3621Z",
    fill: "url(#paint0_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8438 14.3621C13.8438 14.1134 13.9425 13.875 14.1183 13.6991C14.2942 13.5233 14.5326 13.4246 14.7812 13.4246H26.9969C27.2455 13.4246 27.484 13.5233 27.6598 13.6991C27.8356 13.875 27.9344 14.1134 27.9344 14.3621V27.6042C27.9344 27.8529 27.8356 28.0913 27.6598 28.2672C27.484 28.443 27.2455 28.5417 26.9969 28.5417H14.7812C14.5326 28.5417 14.2942 28.443 14.1183 28.2672C13.9425 28.0913 13.8438 27.8529 13.8438 27.6042V14.3621Z",
    fill: "url(#paint1_radial_434_3345)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.3926 16.223C16.3926 16.0987 16.3432 15.9795 16.2553 15.8916C16.1674 15.8037 16.0481 15.7543 15.9238 15.7543C15.7995 15.7543 15.6803 15.8037 15.5924 15.8916C15.5045 15.9795 15.4551 16.0987 15.4551 16.223H16.3926ZM25.1526 15.564C25.1526 15.4396 25.1032 15.3204 25.0153 15.2325C24.9274 15.1446 24.8081 15.0952 24.6838 15.0952C24.5595 15.0952 24.4403 15.1446 24.3524 15.2325C24.2645 15.3204 24.2151 15.4396 24.2151 15.564H25.1526ZM16.3926 18.2293V16.223H15.4551V18.2293H16.3926ZM24.2151 15.564V18.2293H25.1526V15.564H24.2151ZM20.3038 22.448C18.1945 22.448 16.3926 20.588 16.3926 18.2293H15.4551C15.4551 21.0483 17.6207 23.3855 20.3038 23.3855V22.448ZM20.3038 23.3855C22.987 23.3855 25.1526 21.0483 25.1526 18.2293H24.2151C24.2151 20.588 22.4132 22.448 20.3038 22.448V23.3855Z",
    fill: "#F19A39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_i_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.8906 15.636C16.8906 15.5117 16.8412 15.3924 16.7533 15.3045C16.6654 15.2166 16.5462 15.1672 16.4219 15.1672C16.2976 15.1672 16.1783 15.2166 16.0904 15.3045C16.0025 15.3924 15.9531 15.5117 15.9531 15.636H16.8906ZM25.6497 15.636C25.6497 15.5117 25.6003 15.3924 25.5124 15.3045C25.4245 15.2166 25.3053 15.1672 25.1809 15.1672C25.0566 15.1672 24.9374 15.2166 24.8495 15.3045C24.7616 15.3924 24.7122 15.5117 24.7122 15.636H25.6497ZM16.8906 17.6432V15.6369H15.9531V17.6432H16.8906ZM24.7122 15.6369V17.6432H25.6497V15.6369H24.7122ZM20.8009 21.8619C18.6916 21.8619 16.8906 20.0019 16.8906 17.6432H15.9531C15.9531 20.4622 18.1187 22.7994 20.8019 22.7994L20.8009 21.8619ZM20.8019 22.7994C23.4859 22.7994 25.6497 20.4622 25.6497 17.6432H24.7122C24.7122 20.0019 22.9112 21.8619 20.8009 21.8619L20.8019 22.7994Z",
    fill: "#E45A3B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_f_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.6992 15.636C16.6992 15.6049 16.6869 15.5751 16.6649 15.5531C16.6429 15.5311 16.6131 15.5188 16.582 15.5188C16.551 15.5188 16.5211 15.5311 16.4992 15.5531C16.4772 15.5751 16.4648 15.6049 16.4648 15.636H16.6992ZM25.4592 15.636C25.4592 15.6049 25.4469 15.5751 25.4249 15.5531C25.4029 15.5311 25.3731 15.5188 25.342 15.5188C25.311 15.5188 25.2811 15.5311 25.2592 15.5531C25.2372 15.5751 25.2248 15.6049 25.2248 15.636H25.4592ZM16.6992 17.6432V15.6369H16.4648V17.6432H16.6992ZM25.2248 15.6369V17.6432H25.4592V15.6369H25.2248ZM20.962 22.2135C18.637 22.2135 16.6992 20.1744 16.6992 17.6432H16.4648C16.4648 20.2897 18.4936 22.4479 20.962 22.4479V22.2135ZM20.962 22.4479C23.4305 22.4479 25.4592 20.2897 25.4592 17.6432H25.2248C25.2248 20.1744 23.287 22.2135 20.962 22.2135V22.4479Z",
    fill: "url(#paint2_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.6992 15.636C16.6992 15.6049 16.6869 15.5751 16.6649 15.5531C16.6429 15.5311 16.6131 15.5188 16.582 15.5188C16.551 15.5188 16.5211 15.5311 16.4992 15.5531C16.4772 15.5751 16.4648 15.6049 16.4648 15.636H16.6992ZM25.4592 15.636C25.4592 15.6049 25.4469 15.5751 25.4249 15.5531C25.4029 15.5311 25.3731 15.5188 25.342 15.5188C25.311 15.5188 25.2811 15.5311 25.2592 15.5531C25.2372 15.5751 25.2248 15.6049 25.2248 15.636H25.4592ZM16.6992 17.6432V15.6369H16.4648V17.6432H16.6992ZM25.2248 15.6369V17.6432H25.4592V15.6369H25.2248ZM20.962 22.2135C18.637 22.2135 16.6992 20.1744 16.6992 17.6432H16.4648C16.4648 20.2897 18.4936 22.4479 20.962 22.4479V22.2135ZM20.962 22.4479C23.4305 22.4479 25.4592 20.2897 25.4592 17.6432H25.2248C25.2248 20.1744 23.287 22.2135 20.962 22.2135V22.4479Z",
    fill: "url(#paint3_linear_434_3345)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.7109 7.7124H2.82812C2.31036 7.7124 1.89062 8.13213 1.89062 8.6499V25.613C1.89062 26.1308 2.31036 26.5505 2.82812 26.5505H17.7109C18.2287 26.5505 18.6484 26.1308 18.6484 25.613V8.6499C18.6484 8.13213 18.2287 7.7124 17.7109 7.7124Z",
    fill: "url(#paint4_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.7109 7.7124H2.82812C2.31036 7.7124 1.89062 8.13213 1.89062 8.6499V25.613C1.89062 26.1308 2.31036 26.5505 2.82812 26.5505H17.7109C18.2287 26.5505 18.6484 26.1308 18.6484 25.613V8.6499C18.6484 8.13213 18.2287 7.7124 17.7109 7.7124Z",
    fill: "url(#paint5_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.7109 7.7124H2.82812C2.31036 7.7124 1.89062 8.13213 1.89062 8.6499V25.613C1.89062 26.1308 2.31036 26.5505 2.82812 26.5505H17.7109C18.2287 26.5505 18.6484 26.1308 18.6484 25.613V8.6499C18.6484 8.13213 18.2287 7.7124 17.7109 7.7124Z",
    fill: "url(#paint6_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.7109 7.7124H2.82812C2.31036 7.7124 1.89062 8.13213 1.89062 8.6499V25.613C1.89062 26.1308 2.31036 26.5505 2.82812 26.5505H17.7109C18.2287 26.5505 18.6484 26.1308 18.6484 25.613V8.6499C18.6484 8.13213 18.2287 7.7124 17.7109 7.7124Z",
    fill: "url(#paint7_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_f_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.7402 8.61987V25.0261",
    stroke: "url(#paint8_linear_434_3345)",
    strokeWidth: 0.703125,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M1.89062 15.6811V13.5999H18.6475V15.6811H1.89062Z",
    fill: "#3A92EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M1.89062 15.6811V13.5999H18.6475V15.6811H1.89062Z",
    fill: "url(#paint9_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1.89062 15.6811V13.5999H18.6475V15.6811H1.89062Z",
    fill: "url(#paint10_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M1.89062 15.6811V13.5999H18.6475V15.6811H1.89062Z",
    fill: "url(#paint11_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1.89062 20.0461V17.9658H18.6475V20.0461H1.89062Z",
    fill: "#3A91ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M1.89062 20.0461V17.9658H18.6475V20.0461H1.89062Z",
    fill: "url(#paint12_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M1.89062 20.0461V17.9658H18.6475V20.0461H1.89062Z",
    fill: "url(#paint13_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1.89062 20.0461V17.9658H18.6475V20.0461H1.89062Z",
    fill: "url(#paint14_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M1.89062 24.4111V22.3308H18.6475V24.4111H1.89062Z",
    fill: "#3A8FF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M1.89062 24.4111V22.3308H18.6475V24.4111H1.89062Z",
    fill: "url(#paint15_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M1.89062 24.4111V22.3308H18.6475V24.4111H1.89062Z",
    fill: "url(#paint16_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M1.89062 24.4111V22.3308H18.6475V24.4111H1.89062Z",
    fill: "url(#paint17_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_f_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M27.1982 14.2832L27.1973 27.6754",
    stroke: "url(#paint18_linear_434_3345)",
    strokeWidth: 0.703125,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_f_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M14.5176 8.23926V11.1689",
    stroke: "#4EB7F5",
    strokeWidth: 0.703125,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_f_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M5.08398 8.23926V11.1689",
    stroke: "#4EB7F5",
    strokeWidth: 0.703125,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_i_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M14.5315 10.6711C14.5315 10.7954 14.5809 10.9146 14.6688 11.0025C14.7567 11.0904 14.8759 11.1398 15.0002 11.1398C15.1246 11.1398 15.2438 11.0904 15.3317 11.0025C15.4196 10.9146 15.469 10.7954 15.469 10.6711H14.5315ZM5.06836 10.6711C5.06836 10.7954 5.11775 10.9146 5.20565 11.0025C5.29356 11.0904 5.41279 11.1398 5.53711 11.1398C5.66143 11.1398 5.78066 11.0904 5.86857 11.0025C5.95647 10.9146 6.00586 10.7954 6.00586 10.6711H5.06836ZM14.5315 7.32983V10.6711H15.469V7.32983H14.5315ZM6.00586 10.6711V7.32983H5.06836V10.6711H6.00586ZM10.2687 3.11108C12.6049 3.11108 14.5315 5.00577 14.5315 7.32983H15.469C15.469 4.47702 13.1112 2.17358 10.2687 2.17358V3.11108ZM10.2687 2.17358C7.42711 2.17358 5.06836 4.47702 5.06836 7.32983H6.00586C6.00586 5.00577 7.93336 3.11108 10.2687 3.11108V2.17358Z",
    fill: "url(#paint19_radial_434_3345)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    filter: "url(#filter9_f_434_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M15.0452 10.6711C15.0452 10.7022 15.0576 10.732 15.0796 10.754C15.1015 10.776 15.1313 10.7883 15.1624 10.7883C15.1935 10.7883 15.2233 10.776 15.2453 10.754C15.2673 10.732 15.2796 10.7022 15.2796 10.6711H15.0452ZM5.42086 10.6711C5.42086 10.7022 5.43321 10.732 5.45518 10.754C5.47716 10.776 5.50697 10.7883 5.53805 10.7883C5.56913 10.7883 5.59893 10.776 5.62091 10.754C5.64289 10.732 5.65523 10.7022 5.65523 10.6711H5.42086ZM15.0452 7.32987V10.6711H15.2796V7.32987H15.0452ZM5.65523 10.6711L5.6543 7.32987H5.41992V10.6702H5.6543L5.65523 10.6711ZM10.3493 2.7605C12.9209 2.7605 15.0443 4.80987 15.0443 7.33081H15.2787C15.2787 4.67394 13.0437 2.52612 10.3493 2.52612V2.7605ZM10.3493 2.52612C7.65492 2.52612 5.41992 4.673 5.41992 7.32987H5.6543C5.6543 4.80894 7.77773 2.7605 10.3493 2.7605V2.52612Z",
    fill: "url(#paint20_linear_434_3345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M15.0452 10.6711C15.0452 10.7022 15.0576 10.732 15.0796 10.754C15.1015 10.776 15.1313 10.7883 15.1624 10.7883C15.1935 10.7883 15.2233 10.776 15.2453 10.754C15.2673 10.732 15.2796 10.7022 15.2796 10.6711H15.0452ZM5.42086 10.6711C5.42086 10.7022 5.43321 10.732 5.45518 10.754C5.47716 10.776 5.50697 10.7883 5.53805 10.7883C5.56913 10.7883 5.59893 10.776 5.62091 10.754C5.64289 10.732 5.65523 10.7022 5.65523 10.6711H5.42086ZM15.0452 7.32987V10.6711H15.2796V7.32987H15.0452ZM5.65523 10.6711L5.6543 7.32987H5.41992V10.6702H5.6543L5.65523 10.6711ZM10.3493 2.7605C12.9209 2.7605 15.0443 4.80987 15.0443 7.33081H15.2787C15.2787 4.67394 13.0437 2.52612 10.3493 2.52612V2.7605ZM10.3493 2.52612C7.65492 2.52612 5.41992 4.673 5.41992 7.32987H5.6543C5.6543 4.80894 7.77773 2.7605 10.3493 2.7605V2.52612Z",
    fill: "url(#paint21_linear_434_3345)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_434_3345",
    x: 13.8438,
    y: 12.9558,
    width: 14.5586,
    height: 15.5859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.556863 0 0 0 0 0.329412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_434_3345",
    x: 14.5176,
    y: 14.1577,
    width: 11.5723,
    height: 10.1653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875,
    result: "effect1_foregroundBlur_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_434_3345",
    x: 15.9531,
    y: 15.1672,
    width: 9.88477,
    height: 7.63208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.321569 0 0 0 0 0.109804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_434_3345",
    x: 16.3242,
    y: 15.3782,
    width: 9.27539,
    height: 7.21021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0703125,
    result: "effect1_foregroundBlur_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_434_3345",
    x: 16.6855,
    y: 7.56519,
    width: 2.10938,
    height: 18.5156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562,
    result: "effect1_foregroundBlur_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_434_3345",
    x: 26.377,
    y: 13.4629,
    width: 1.64062,
    height: 15.0327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375,
    result: "effect1_foregroundBlur_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_434_3345",
    x: 13.2285,
    y: 6.9502,
    width: 2.57812,
    height: 5.50781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875,
    result: "effect1_foregroundBlur_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_434_3345",
    x: 3.79492,
    y: 6.9502,
    width: 2.57812,
    height: 5.50781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875,
    result: "effect1_foregroundBlur_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_434_3345",
    x: 5.06836,
    y: 2.07983,
    width: 10.4004,
    height: 9.06006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.560784 0 0 0 0 0.886275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3345"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_434_3345",
    x: 5.18555,
    y: 2.29175,
    width: 10.3281,
    height: 8.73096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_3345",
    x1: 17.3884,
    y1: 16.5014,
    x2: 22.1341,
    y2: 24.7046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB046"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_434_3345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6872 25.9518) rotate(52.08) scale(3.28405 4.46706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#D38D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38D3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_3345",
    x1: 24.4561,
    y1: 15.2994,
    x2: 24.4561,
    y2: 21.1738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38362",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_434_3345",
    x1: 17.7108,
    y1: 21.1738,
    x2: 23.6283,
    y2: 21.1738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38362",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_434_3345",
    x1: 10.2691,
    y1: 7.7124,
    x2: 10.2691,
    y2: 26.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_434_3345",
    x1: 1.89062,
    y1: 24.3821,
    x2: 3.53125,
    y2: 24.3821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#449FEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_434_3345",
    x1: 9.94656,
    y1: 26.9893,
    x2: 9.94656,
    y2: 22.8877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4676F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_434_3345",
    x1: 10.2691,
    y1: 7.7124,
    x2: 10.2691,
    y2: 9.73365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#61C9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61C9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_434_3345",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#5BB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_434_3345",
    x1: 1.89062,
    y1: 15.0361,
    x2: 3.61844,
    y2: 15.0361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2A81CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A81CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_434_3345",
    x1: 18.6484,
    y1: 15.0361,
    x2: 17.0078,
    y2: 15.0361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51A9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A9F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_434_3345",
    x1: 18.6484,
    y1: 15.6811,
    x2: 17.8862,
    y2: 15.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C97EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_434_3345",
    x1: 1.89062,
    y1: 19.4011,
    x2: 3.61844,
    y2: 19.4011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2A81CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A81CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_434_3345",
    x1: 18.6484,
    y1: 19.4011,
    x2: 17.0078,
    y2: 19.4011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51A9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A9F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_434_3345",
    x1: 18.6484,
    y1: 20.0461,
    x2: 17.8862,
    y2: 20.0461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C97EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_434_3345",
    x1: 1.89062,
    y1: 23.7671,
    x2: 3.61844,
    y2: 23.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2A81CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A81CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_434_3345",
    x1: 18.6484,
    y1: 23.7671,
    x2: 17.0078,
    y2: 23.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51A9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A9F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_434_3345",
    x1: 18.6484,
    y1: 24.4111,
    x2: 17.8862,
    y2: 24.4111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C97EE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_434_3345",
    x1: 612476,
    y1: 14.0263,
    x2: 612476,
    y2: 26.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB84A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_434_3345",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.95398 3.11202) rotate(72.9753) scale(7.905 9.31867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C94E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C9CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_434_3345",
    x1: 11.6618,
    y1: 11.1399,
    x2: 11.6618,
    y2: 6.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53A9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A9F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_434_3345",
    x1: 14.8109,
    y1: 4.43112,
    x2: 12.9649,
    y2: 6.65769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61B2F2",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiShoppingBags);
export default __webpack_public_path__ + "static/media/fluent-emoji_shopping-bags.8c06f8af4979cf0460e1c0b486e07cd6.svg";
export { ForwardRef as ReactComponent };